import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useSaveMedicine() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((medicineId, payload) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = medicineId
      ? quarkusApi.put(`/medicines/${medicineId}`, payload, authHeader)
      : quarkusApi.post('/medicines', payload, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
